import * as EmailValidator from "email-validator";
import DOMPurify from "dompurify";
import {FormElement} from "./types";


// function to check if input is valid email format
export const isValidEmailFormat = (input: string) : boolean => {
    return EmailValidator.validate(input);
}


// function to check if input is valid phone format
export const isValidPhoneFormat = (input: string): boolean => {
    const validRegex = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
    return !!input.match(validRegex);

}

export const isValidFirstOrLastName = (input: string) : boolean => {
    const validRegex = "^[A-Za-z]+$";
    if(input.match(validRegex)) {
        return true;
    }
    return false;

}

// Utility function to sanitize input data
export const sanitizeInput = (input: string) => {
    // Sanitize the input strictly
    return DOMPurify.sanitize(input, {
        ALLOWED_TAGS: [], // Don't allow any tags
        ALLOWED_ATTR: [], // Don't allow any attributes
    });
};


// validates a list of input sets.
export const isValidInputSet = (
    formData: FormElement[]
): { updatedData: FormElement[]; isValid: boolean } => {
    let valid = true;

    const updatedData = formData.map((input) => {
        let error = "";

        switch (input.type) {
            case "text":
            case "textarea":
                if (!input.value || input.value.trim() === "") {
                    valid = false;
                    error = "Veuillez remplir ce champ obligatoire.";
                }
                break;

            case "email":
                if (!input.value || input.value.trim() === "") {
                    valid = false;
                    error = "Veuillez remplir ce champ obligatoire.";
                } else if (!isValidEmailFormat(input.value)) {
                    valid = false;
                    error = "Format de courriel invalide";
                }
                break;

            case "phone":
                if (!input.value || input.value.trim() === "") {
                    valid = false;
                    error = "Veuillez remplir ce champ obligatoire.";
                } else if (!isValidPhoneFormat(input.value)) {
                    valid = false;
                    error = "Un numéro de téléphone valide ne peut contenir que des chiffres.";
                }
                break;

            case "date":
                if (!input.value || input.value.trim() === "") {
                    valid = false;
                    error = "Veuillez remplir ce champ obligatoire.";
                }
                break;
        }

        return { ...input, error };
    });

    return { updatedData, isValid: valid };
};
